import * as React from 'react';

import type { ICianMFUIElement } from '@cian/mf-registry/browser';

interface IUseAdBannerMicrofrontendResult {
  microfrontendRef: React.RefObject<ICianMFUIElement | null>;
  isReady: boolean;
}

/**
 * Откладывает маунт микрофронтенда до клиента: реклама не должна рендериться на SSR.
 * Пока isReady false, место держит плейсхолдер.
 */
export function useAdBannerMicrofrontend(): IUseAdBannerMicrofrontendResult {
  const microfrontendRef = React.useRef<ICianMFUIElement | null>(null);
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => setIsReady(true), 0);

    return () => clearTimeout(timeoutId);
  }, []);

  return { microfrontendRef, isReady };
}
